export const modifierList = ['editorial-premium', 'narrow-article', 'bg-dark'];
